import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "./BaseController";
import Wizard from "sap/m/Wizard";
import Input from "sap/m/Input";
import ResourceBundle from "sap/base/i18n/ResourceBundle";
import MessageBox from "sap/m/MessageBox";
import AuthenticationService from "../util/AuthenticationService";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default abstract class ForgotPassword extends BaseController {

	onInit(): void {
		const viewModel = new JSONModel({
			mailStepEnabled: true,
			verificationStepEnabled: true,
			pwStepEnabled: true,
			verificationCode: undefined,
			email: undefined,
			password: undefined,
			passwordRepeat: undefined
		});

		this.getView().setModel(viewModel);
	}

	//*************************************************************************************
	// EVENT HANDLERS
	//*************************************************************************************

	onBackToLogin(): void {
		this.navTo("login");
	}

	async onConfirmEmail(): Promise<void> {

		const model = this.getView().getModel() as JSONModel;
		const inputField = this.byId("inputEmail") as Input;
		const mail = model.getProperty("/email");
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (regex.test(mail)) {
			await AuthenticationService.resetPassword(mail);
			(this.byId("PwForgetWizard") as Wizard).nextStep();
			model.setProperty("/mailStepEnabled", false);
			inputField.setValueState("None");
			inputField.setValueStateText("");
		} else {
			inputField.setValueState("Error");
			const errorMessage = (this.getResourceBundle() as ResourceBundle).getText("notValid")
			inputField.setValueStateText(errorMessage);
		}
	}

	async onConfirmVerificationCode(): Promise<void> {

		const model = this.getView().getModel() as JSONModel;
		const inputField = this.byId("inputVerificationCode") as Input;
		const verificationCode = this.getView().getModel().getProperty("/verificationCode") as string;

		if (verificationCode.length == 6) {
			(this.byId("PwForgetWizard") as Wizard).nextStep();
			model.setProperty("/verificationStepEnabled", false);
			inputField.setValueState("None");
			inputField.setValueStateText("");
		} else {
			inputField.setValueState("Error");
			const errorMessage = (this.getResourceBundle() as ResourceBundle).getText("notValid")
			inputField.setValueStateText(errorMessage);
		}
	}

	async onConfirmPasswordChange(): Promise<void> {

		const model = this.getView().getModel();
		const inputField = this.byId("pwRepeat") as Input;
		const password = model.getProperty("/password") as string;
		const passwordRepeat = model.getProperty("/passwordRepeat") as string;

		if (password == passwordRepeat) {
			await AuthenticationService.confirmPasswordChange(model.getProperty("/email"), model.getProperty("/verificationCode"), password);
			inputField.setValueState("None");
			inputField.setValueStateText("");
			const wizard = this.byId("PwForgetWizard") as Wizard;
			const steps = wizard.getSteps();
			wizard.discardProgress(steps[0], true);
			this.onInit();
			this.navTo("login");
		} else {
			inputField.setValueState("Error");
			const errorMessage = (this.getResourceBundle() as ResourceBundle).getText("pwNotSimilar")
			inputField.setValueStateText(errorMessage);
		}
	}
}
